import { avoidAuthToken } from "./../../../constants";
import LoginFlowConfigURL from "@adapters/infrastructures/urlConfig/LoginFlow/LoginFlowConfigURL";
import clientValidateOTPMapper from "@domains/features/LoginFlow/mapper/clientValidateOTPMapper";
import clientGenerateOTPMapper from "@domains/features/LoginFlow/mapper/clientGenOTPMapper";
import guestValidateMapper from "@domains/features/LoginFlow/mapper/guestValidateMapper";
import clientSetPasswordMapper from "@domains/features/LoginFlow/mapper/clientSetPassword";
import ClientForgotUserIDMapper from "@domains/features/LoginFlow/mapper/clientForgotUserID";
import guestLoginSetMpinMapper from "@domains/features/LoginFlow/mapper/guestLoginSetMPIN";
import validateMPINMapper from "@domains/features/LoginFlow/mapper/GuestValidateMPIN";
import getAccountDetailsMapper from "@domains/features/LoginFlow/mapper/getAccountDetailsMapper";
import { LoginClientDataMapper } from "@domains/features/LoginFlow/mapper/ClientLoginMapper";
import checkNAddEmailMapper from "@domains/features/LoginFlow/mapper/iCheckNAddEmail";
import { addAccountMapper } from "@domains/features/LoginFlow/mapper/addAccountMapper";
import GuestForgotPINMapper from "@domains/features/LoginFlow/mapper/guestForgotPIN";
import clientValidateUserIDMapper from "@domains/features/LoginFlow/mapper/clientValidateUserID";
import clientValidatePasswordMapper from "@domains/features/LoginFlow/mapper/clientValidatePasswordMapper";
import unblockUserMapper from "@domains/features/LoginFlow/mapper/unblockUserMapper";
import guestRegEmailVerifyOTPMapper from "@domains/features/LoginFlow/mapper/guestRegEmailVerifyOTPMapper";
class LoginFLowRepository {
    constructor(http) {
        this.http = http;
    }
    async getUnblockUser(req) {
        const url = new URL(`${LoginFlowConfigURL.loginBaseKambalaloginHelpUrl}${LoginFlowConfigURL.unblockUser}${req.userId}`);
        const unblockUser = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
        });
        return unblockUserMapper(unblockUser === null || unblockUser === void 0 ? void 0 : unblockUser.data);
    }
    async clientSetPassword(req) {
        const url = new URL(LoginFlowConfigURL.loginBaseKambalaloginHelpUrl +
            LoginFlowConfigURL.setPassword +
            req.userID);
        const clientSetPassword = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req.clientSetPassword,
        });
        return clientSetPasswordMapper(clientSetPassword);
    }
    async clientValidateOTP(req) {
        const url = new URL(LoginFlowConfigURL.loginBaseUrl +
            req.userID +
            LoginFlowConfigURL.clientValidateOTP);
        const clientValidate = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req.validateReq,
        });
        return clientValidateOTPMapper(clientValidate);
    }
    async clientGenerateOTP(req) {
        const url = new URL(LoginFlowConfigURL.loginBaseKambalaloginHelpUrl +
            LoginFlowConfigURL.generateOTP +
            req.userID);
        const clientGenerateOTP = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req.clientReq,
        });
        return clientGenerateOTPMapper(clientGenerateOTP);
    }
    async clientForgotUserID(req) {
        const url = new URL(LoginFlowConfigURL.loginBaseKambalaloginHelpUrl +
            LoginFlowConfigURL.clientForgetUserID);
        const clientForgotUserID = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
        });
        return ClientForgotUserIDMapper(clientForgotUserID);
    }
    async getImage(req) {
        const url = new URL(`${LoginFlowConfigURL.loginBaseKambalaUrl}${LoginFlowConfigURL.clientLoginValidateUser}${req.userId}`);
        const clientValidateUserID = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            avoidAuthToken,
        });
        return clientValidateUserIDMapper(clientValidateUserID === null || clientValidateUserID === void 0 ? void 0 : clientValidateUserID.data);
    }
    async getQuestionsForLogin(req) {
        const url = new URL(`${LoginFlowConfigURL.loginBaseKambalaUrl}${LoginFlowConfigURL.clientLoginValidatePassword}${req.userId}`);
        const request = {
            accTyp: req.accType,
            ip: "",
            pwd: req.pwd,
        };
        const questionData = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: request,
        });
        return clientValidatePasswordMapper(questionData === null || questionData === void 0 ? void 0 : questionData.data);
    }
    async guestLoginSetMpin(req) {
        const url = new URL(LoginFlowConfigURL.guestRealBaseAPI + LoginFlowConfigURL.guestSetMPIN);
        const guestLoginSetMpin = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
            avoidAppID: true,
        });
        return guestLoginSetMpinMapper(guestLoginSetMpin);
    }
    async guestLoginValidateMPIN(req) {
        const url = new URL(LoginFlowConfigURL.guestRealBaseAPI + LoginFlowConfigURL.validateMPIN);
        const validateMPIN = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
            avoidAppID: true,
        });
        return validateMPINMapper(validateMPIN === null || validateMPIN === void 0 ? void 0 : validateMPIN.data);
    }
    async getAccountDetails(req) {
        const url = new URL(LoginFlowConfigURL.guestRealBaseAPI + LoginFlowConfigURL.accountCheck);
        url.searchParams.append("cryCd", req.crycd);
        url.searchParams.append("mob", req.mob);
        const getAccountDetails = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return getAccountDetailsMapper(getAccountDetails === null || getAccountDetails === void 0 ? void 0 : getAccountDetails.data);
    }
    async getLoginDataForOtp(req) {
        const url = new URL(`${LoginFlowConfigURL.loginBaseKambalaUrl}${LoginFlowConfigURL.clientLoginvalidateOTP}${req.userId}`);
        const loginData = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
        });
        return LoginClientDataMapper(loginData === null || loginData === void 0 ? void 0 : loginData.data);
    }
    async checkNAddEmail(req) {
        const url = new URL(LoginFlowConfigURL.guestRealBaseAPI + LoginFlowConfigURL.checknaddEmail);
        const checknaddEmail = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
            avoidAppID: true,
        });
        return checkNAddEmailMapper(checknaddEmail === null || checknaddEmail === void 0 ? void 0 : checknaddEmail.data);
    }
    async guestRegisterAddAccount(req) {
        const url = new URL(LoginFlowConfigURL.guestRealBaseAPI + LoginFlowConfigURL.addAccount);
        const addAccount = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
            avoidAppID: true,
        });
        return addAccountMapper(addAccount === null || addAccount === void 0 ? void 0 : addAccount.data);
    }
    async guestForgotPIN(req) {
        const url = new URL(LoginFlowConfigURL.guestRealBaseAPI + LoginFlowConfigURL.forgotPIN);
        const guestForgotPIN = await this.http.makeApiCall({
            method: "PUT",
            url: url.toString(),
            body: req,
        });
        return GuestForgotPINMapper(guestForgotPIN === null || guestForgotPIN === void 0 ? void 0 : guestForgotPIN.data);
    }
    async guestRegValidateOTP(req) {
        const url = new URL(LoginFlowConfigURL.guestRealBaseAPI + LoginFlowConfigURL.guestValidate);
        const guestValidate = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
            avoidAppID: true,
        });
        return guestValidateMapper(guestValidate === null || guestValidate === void 0 ? void 0 : guestValidate.data);
    }
    async guestRegEmailVerifyOTP(req) {
        const url = new URL(LoginFlowConfigURL.guestRealBaseAPI + LoginFlowConfigURL.guestverifyEmail);
        const EmailVerifyOTP = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
            avoidAppID: true,
        });
        return guestRegEmailVerifyOTPMapper(EmailVerifyOTP === null || EmailVerifyOTP === void 0 ? void 0 : EmailVerifyOTP.data);
    }
}
export default LoginFLowRepository;
